<template
  ><div>
    <v-speed-dial direction="bottom" right="" open-on-hover transition="scale">
      <template v-slot:activator>
        <v-btn fab>
          <v-avatar>
            <v-img :src="image || defaultImage" />
          </v-avatar>
        </v-btn>
      </template>

      <v-btn fab dark small color="primary" @click="launchFilePicker">
        <v-icon>mdi-pencil</v-icon>
      </v-btn>
      <v-btn fab dark small color="red" v-if="image" @click="deleteImage">
        <v-icon>mdi-delete</v-icon>
      </v-btn>
    </v-speed-dial>

    <input
      type="file"
      ref="file"
      :name="uploadFieldName"
      @change="previewImage"
      style="display:none"
      accept="image/*"
    />
  </div>
</template>

<script>
export default {
  name: "RoundButtonImage",
  data: () => ({
    errorDialog: null,
    errorText: "",
    uploadFieldName: "file",
    maxSize: 1024,
    defaultImage: require("@/assets/no-image.png")
  }),
  methods: {
    launchFilePicker() {
      this.$refs.file.click();
    },
    deleteImage() {
      // this.$refs.file.files.remove();
      this.$refs.file.value = "";
      this.$emit("change", "");
    },
    previewImage: function(event) {
      // Reference to the DOM input element
      var input = event.target;
      // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) {
        // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader();
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = e => {
          // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
          // Read image as base64 and set to imageData
          this.$emit("change", e.target.result);
        };
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(input.files[0]);
      }
    }
  },

  props: {
    image: {
      type: String,
      default: function() {
        return "";
      }
    }
  }
};
</script>
